import * as v from 'valibot';

/**
 * Envelope guard for `GET /auth/session` — see `getValidated` in `utils/api.ts` for why these
 * schemas are `looseObject` with `nullish` leaves rather than the source of the exported types.
 *
 * `manager` is nullable by design (anonymous visitor), and independent of `connectEnabled`
 * (the API can disable new connections while existing sessions still resolve).
 */
export const sessionManagerSchema = v.looseObject({
  sorareId: v.nullish(v.string()),
  slug: v.nullish(v.string()),
  name: v.nullish(v.string()),
  clubName: v.nullish(v.string()),
  pictureUrl: v.nullish(v.string()),
});

export const sessionSchema = v.looseObject({
  connectEnabled: v.nullish(v.boolean()),
  manager: v.nullish(sessionManagerSchema),
});
